import * as React from 'react';

import {getHumanReadableDueUnit} from 'nutshell-core/date-time/delays';
import type {DueDateUnit} from 'nutshell-core/types';

import {Checkbox} from 'shells/checkbox/checkbox';
import {DelayInput} from 'shells/delay-bar/delay-input';
import {FormField} from 'shells/form/form-field';

import type {TimespanInput} from 'nutshell-graphql-types';

import styles from './set-optional-delay.module.css';

type Props = {
    onSetOptionalDelay: (arg1?: TimespanInput | null | undefined) => void;
    delay: TimespanInput | null | undefined;
    initialDelay: TimespanInput | null | undefined;
};

export function SetOptionalDelay(props: Props) {
    const [isChecked, setIsChecked] = React.useState<boolean>(Boolean(props.initialDelay));

    const delay = props.delay;

    // This is just a nice thing to do if the checkbox is accidentally unchecked it will put the initial delay back
    const defaultDelay = props.initialDelay
        ? {
              unit: props.initialDelay.unit,
              timespan: props.initialDelay.timespan,
          }
        : // Default to 3 days if there was no initial delay
          {unit: 'dd', timespan: 3};

    return (
        <FormField innerId='set-optional-delay'>
            <div>
                <Checkbox
                    checked={isChecked}
                    isLarge={true}
                    label='Set an optional delay'
                    onChange={(newValue) => {
                        setIsChecked(newValue);
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        newValue
                            ? // @ts-expect-error
                              props.onSetOptionalDelay(defaultDelay)
                            : props.onSetOptionalDelay(null);
                    }}
                />
                {isChecked && delay ? (
                    <>
                        <div className={styles['delay-input-wrapper']}>
                            <DelayInput
                                selectedOption={delay.unit}
                                inputValue={delay.timespan}
                                onInputChange={(value) => {
                                    props.onSetOptionalDelay({unit: delay.unit, timespan: value});
                                }}
                                onSelectChange={(value) => {
                                    props.onSetOptionalDelay({
                                        unit: value,
                                        timespan: delay.timespan,
                                    });
                                }}
                            />
                        </div>
                        <p className={styles['delay-text']}>
                            Start sending {delay.timespan}{' '}
                            {getTimeUnitTextFromValue(delay.timespan, delay.unit)} after the start
                            trigger occurs
                        </p>
                    </>
                ) : undefined}
            </div>
        </FormField>
    );
}

const getTimeUnitTextFromValue = (value: number, unit: DueDateUnit): string => {
    let text = getHumanReadableDueUnit(unit);

    if (value === 1) {
        text = text.substring(0, text.length - 1);
    }

    return text;
};
